import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import PicklistOption from 'react-rainbow-components/components/PicklistOption';
import { useFirebaseApp } from '@rainbow-modules/firebase-hooks';
import getUserFleets from '../../services/getUserFleets';
import { Container } from './styled';

function findGroup(value, fleets) {
  if (value && typeof value === 'string') {
    var groupSelected = fleets.find(function (fleet) {
      return fleet.id === value;
    });

    if (groupSelected) {
      var id = groupSelected.id,
          name = groupSelected.name;
      return {
        name: id,
        label: name
      };
    }
  }

  return undefined;
}

function FleetOptions(_ref) {
  var fleets = _ref.fleets;
  return fleets.map(function (_ref2) {
    var id = _ref2.id,
        name = _ref2.name;
    return /*#__PURE__*/React.createElement(PicklistOption, {
      key: id,
      name: id,
      label: name
    });
  });
}

export default function FleetPicker(props) {
  var className = props.className,
      style = props.style,
      idProp = props.id,
      _onChange = props.onChange,
      value = props.value;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      fleets = _useState2[0],
      setFleets = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var app = useFirebaseApp();
  var group = findGroup(value, fleets);
  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var groups;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return getUserFleets(app);

            case 3:
              groups = _context.sent;
              setIsLoading(false);
              setFleets(groups);
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              setIsLoading(false);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }))();
  }, [app]);
  useEffect(function () {
    if (fleets && fleets.length > 0 && !group) {
      _onChange(fleets[0].id);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [fleets]);
  return /*#__PURE__*/React.createElement(Container, {
    className: className,
    style: style,
    label: "Select Fleet",
    hideLabel: true,
    placeholder: "Select Fleet",
    enableSearch: !isLoading,
    value: group,
    isLoading: isLoading,
    id: idProp,
    onChange: function onChange(fleet) {
      return _onChange(fleet.name);
    }
  }, /*#__PURE__*/React.createElement(PicklistOption, {
    name: "header",
    label: "Select Fleet",
    variant: "header"
  }), /*#__PURE__*/React.createElement(FleetOptions, {
    fleets: fleets
  }));
}
FleetPicker.defaultProps = {
  className: undefined,
  style: undefined,
  id: undefined,
  onChange: function onChange() {},
  value: undefined
};